import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KpiService {
  Url= '';
  UrlPie: string;
  UrlLine: string;
  baseURL = environment.baseAPIURL;
  constructor( private readonly http  : HttpClient) { }

  getFilter()
  {
    return this.http.get(`${this.baseURL}/aetKpi/getFilters`)
    .pipe(catchError(this.handleError) )
  }

  getBarGraph(eId: any[],plId,startDate,endDate)
  { 
    this.Url = '';
    eId.forEach(id =>{ 
      this.Url = this.Url+'eId='+(id.label)+'&';  
    })
    this.Url = this.Url.substring(0, this.Url.length-1);
    return this.http.get(`${this.baseURL}/aetKpi/getBarGraph?${this.Url}&plId=${plId}&startDate=${startDate}&endDate=${endDate}`)
    .pipe(catchError(this.handleError) )
  }

  getPieGraph(eId: any[],plId,startDate,endDate){

    this.UrlPie = '';
    eId.forEach(id =>{ 
      this.UrlPie = this.UrlPie+'eId='+(id.label)+'&';  
    })
    this.UrlPie = this.UrlPie.substring(0, this.UrlPie.length-1);
    
    return this.http.get(`${this.baseURL}/aetKpi/getPieGraph?${this.UrlPie}&plId=${plId}&startDate=${startDate}&endDate=${endDate}`)
    .pipe(catchError(this.handleError) )
  }

  getLineGraph(eId: any[],plId,startDate,endDate,flag){

    this.UrlLine = '';
    eId.forEach(id =>{ 
      this.UrlLine = this.UrlLine+'eId='+(id.label)+'&';  
    })
    this.UrlLine = this.UrlLine.substring(0, this.UrlLine.length-1);
    
    return this.http.get(`${this.baseURL}/aetKpi/getLineGraph?${this.UrlLine}&plId=${plId}&startDate=${startDate}&endDate=${endDate}&flag=${flag}`)
    .pipe(catchError(this.handleError) )
  }

  getBarExcel(eId: any[],plId: any[],startDate,endDate){
    this.Url= '';
    eId.forEach(id =>{ 
      this.Url = this.Url+'eId='+(id.label)+'&';  
    })
    plId.forEach(id =>{ 
      this.Url = this.Url+'plId='+(id.label)+'&';  
    })
    this.Url = this.Url.substring(0, this.Url.length-1);
    
    return this.http.get(`${this.baseURL}/aetKpi/getBarGraph?${this.Url}&startDate=${startDate}&endDate=${endDate}`)
    .pipe(catchError(this.handleError) )
  }

  getPieExcel(eId: any[],plId: any[],startDate,endDate){
    this.Url= '';
    eId.forEach(id =>{ 
      this.Url = this.Url+'eId='+(id.label)+'&';  
    })
    plId.forEach(id =>{ 
      this.Url = this.Url+'plId='+(id.label)+'&';  
    })
    this.Url = this.Url.substring(0, this.Url.length-1);
    
    return this.http.get(`${this.baseURL}/aetKpi/getPieGraph?${this.Url}&startDate=${startDate}&endDate=${endDate}`)
    .pipe(catchError(this.handleError) )
  }

  getLineExcel(eId: any[],plId: any[],startDate,endDate,flag){
    this.Url= '';
    eId.forEach(id =>{ 
      this.Url = this.Url+'eId='+(id.label)+'&';  
    })
    plId.forEach(id =>{ 
      this.Url = this.Url+'plId='+(id.label)+'&';  
    })
    this.Url = this.Url.substring(0, this.Url.length-1);
    
    return this.http.get(`${this.baseURL}/aetKpi/getLineGraph?${this.Url}&startDate=${startDate}&endDate=${endDate}&flag=${flag}`)
    .pipe(catchError(this.handleError) )
  }

  private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}
